export const NotificationView = (props: {
  header?: string;
  content: JSX.Element | string;
}): JSX.Element => {
  const { header, content } = props;
  const resultHeader = header !== undefined ? <h4>{header}</h4> : <></>;
  return (
    <div>
      {resultHeader}
      {content}
    </div>
  );
};
